export default {
  settings: [],
  isLoading: false,
  isSaving: false,
  error: null,
};
